import { useState, useEffect } from "react";
import BackHomeButton from "../components/BackHomeButton";
import { getAuth, SAMLAuthProvider } from 'firebase/auth';
import { useLocation } from 'react-router-dom';
import RazorpayButton from '../components/RazorpayButton';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase';

import html2pdf from 'html2pdf.js';
import logo from '../New_Logo.png'; // Replace with actual logo path

import { functions } from '../firebase'; // Ensure path is correct
import { httpsCallable } from 'firebase/functions';

import {
  doc, getDoc, getFirestore, collection, addDoc,updateDoc,
  serverTimestamp, query, where, getDocs,setDoc,deleteDoc 
} from 'firebase/firestore';
import {
  getStorage, ref, uploadString,  uploadBytesResumable,
  getDownloadURL,listAll, uploadBytes
} from 'firebase/storage';

function Eascode_Vision() {

  const MAX_FILE_SIZE_MB = 3;
  let combinedText = "";
  const navigate = useNavigate();

  // ✅ Helper: Convert file to base64
  function getBase64(fileObj) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      const parts = result.split(",");
      resolve(parts.length > 1 ? parts[1] : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(fileObj);
  });
}

  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [extractedText, setExtractedText] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showText, setShowText] = useState(false);
  //const db = getFirestore();
    //const auth = getAuth();
    const storage = getStorage();

  const [subject, setSubject] = useState('');
  const [subjectList, setSubjectList] = useState([]);
  const [standard, setStandard] = useState('unspecified');
  const user = auth.currentUser;
  const [school, setSchool] = useState('unspecified');
  const [UserType,setUserType]=useState('');
  const [ Premiumenddate,setPremiumenddate ] = useState('');
  const [generationsLeft, setGenerationsLeft] = useState('');
  const location = useLocation();
  const [extraInfo, setExtraInfo] = useState('');
  const [aiResult, setAiResult] = useState('');
  const [hoveredButton, setHoveredButton] = useState(null);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [selectedLessonText, setSelectedLessonText] = useState('');

  const [similar,setsimilar] = useState(false);

  // --- ADD THIS FOR TOGGLE ---
  const [activeMode, setActiveMode] = useState('image'); // Default is image for this page

  const STORAGE_IMAGE_ROOT = "vision_images";

const [storageImages, setStorageImages] = useState([]);
const [loadingStorageImages, setLoadingStorageImages] = useState(false);
const [storageImageError, setStorageImageError] = useState("");
const [selectedStorageImages, setSelectedStorageImages] = useState([]);

const safeStoragePathSegment = (value) =>
  String(value || "unspecified").trim().replace(/\//g, "-");

const buildStorageFolderPath = () => {
  return `${STORAGE_IMAGE_ROOT}/${safeStoragePathSegment(school)}/${safeStoragePathSegment(standard)}/${safeStoragePathSegment(subject)}`;
};

const getStorageImageMimeType = (fileName = "") => {
  const lowerName = fileName.toLowerCase();
  if (lowerName.endsWith(".png")) return "image/png";
  if (lowerName.endsWith(".webp")) return "image/webp";
  return "image/jpeg";
};

useEffect(() => {
  const fetchStorageImages = async () => {
    if (!school || !standard || !subject) {
      setStorageImages([]);
      return;
    }

    setLoadingStorageImages(true);
    setStorageImageError("");

    try {
      const folderRef = ref(storage, buildStorageFolderPath());
      const result = await listAll(folderRef);

      const images = await Promise.all(
        result.items
          .filter((itemRef) => /\.(png|jpg|jpeg|webp)$/i.test(itemRef.name))
          .map(async (itemRef) => ({
            name: itemRef.name,
            fullPath: itemRef.fullPath,
            mimeType: getStorageImageMimeType(itemRef.name),
            url: await getDownloadURL(itemRef),
          }))
      );

      setStorageImages(images);
    } catch (error) {
      console.error("Error loading storage images:", error);
      setStorageImages([]);
      setStorageImageError("Could not load images for this school, standard and subject.");
    } finally {
      setLoadingStorageImages(false);
    }
  };

  fetchStorageImages();
}, [school, standard, subject]);

const handleSelectStorageImage = (image) => {
  setFiles([]);
  setExtractedText("");
  setAiResult("");
  setMessage("");

  setSelectedStorageImages((prevImages) => {
    const alreadySelected = prevImages.some((item) => item.fullPath === image.fullPath);
    const updatedImages = alreadySelected
      ? prevImages.filter((item) => item.fullPath !== image.fullPath)
      : [...prevImages, image];

    setPreviews(updatedImages.map((item) => item.url));
    return updatedImages;
  });
};

const uploadManualImagesForReview = async (images) => {
  const currentUser = auth.currentUser || user;
  if (!currentUser?.uid || !images.length) return;

  const profileSchool = safeStoragePathSegment(school);
  const profileStandard = safeStoragePathSegment(standard);

  if (
    !profileSchool ||
    !profileStandard ||
    profileSchool === "unspecified" ||
    profileStandard === "unspecified"
  ) {
    return;
  }

  const uploadedAt = Date.now();

  try {
    await Promise.all(
      images.map((file, index) => {
        const originalName = file.name || `image_${index + 1}.jpg`;
        const safeFileName = originalName.replace(/[^\w.-]/g, "_");
        const storagePath = `${STORAGE_IMAGE_ROOT}/${profileSchool}/${profileStandard}/${currentUser.uid}/${uploadedAt}_${index + 1}_${safeFileName}`;
        const storageRef = ref(storage, storagePath);

        return uploadBytes(storageRef, file, {
          contentType: file.type || "image/jpeg",
          customMetadata: {
            uploadedByUid: currentUser.uid,
            uploadedByEmail: currentUser.email || "",
            source: "Eascode_Vision_manual_upload",
            subject: subject || "",
          },
        });
      })
    );
  } catch (error) {
    console.error("Error saving manual images for admin review:", error);
  }
};

  const handleToggleChange = (mode) => {
    if (mode === 'lesson') {
      navigate('/Eascode_Agent_Lesson', { state: { subject } }); 
    }
  };
  // ---------------------------

  const get7DayWindow = () => {
  const now = new Date();
  return new Date(now.setDate(now.getDate() - 30));
};

const getToday = () => {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');

  return `${day}${month}${year}_${hours}${minutes}${seconds}`;

};

  const handleNavigation = (path, state = {}) => {
    navigate(path, { state });
  };

  useEffect(() => {
    const state = location.state;
    if (state) {
      if (state.subject) setSubject(state.subject);
    }
  }, [location.state]);

   useEffect(() => {
     if (!user) return;
   
     const fetchProfileAndGenerations = async () => {
       try {
         // 1️⃣ Fetch profile first
         const profileRef = doc(db, 'profiles', user.uid);
         const profileSnap = await getDoc(profileRef);
   
         if (!profileSnap.exists()) return;
   
         const profileData = profileSnap.data();
         const type = profileData.paidUser || false;
         const endDate = profileData.paidUser_End_Date
           ?.toDate?.()
           ?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
           .replace(/ /g, '-') || 'Not Set';
   
         setStandard(profileData.standard || 'unspecified');
         setSchool(profileData.school || 'unspecified');
         setUserType(type);
         setPremiumenddate(endDate);
   
         // 2️⃣ Now check generation count
         const todays_date = `${String(new Date().getDate()).padStart(2, '0')}-${["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"][new Date().getMonth()]}-${new Date().getFullYear()}`;
   
         // Paid & active
         if (type === true && new Date(endDate) >= new Date(todays_date)) {
           setGenerationsLeft(999);
           return;
         }
   
         // Paid but expired
         if (type === true && new Date(endDate) < new Date(todays_date)) {
           alert("The Premium Eascode Service has ended.");
           await deleteDoc(doc(db, 'weekly_generations', user.uid));
           await updateDoc(doc(db, 'profiles', user.uid), { paidUser: false });
           return;
         }
   
         // Free user limit check
         const uid = user.uid;
         const docRef = doc(db, 'weekly_generations', uid);
         const docSnap = await getDoc(docRef);
         const sevenDaysAgo = get7DayWindow();
   
         if (!docSnap.exists()) {
           await setDoc(docRef, { timestamps: [] });
           setGenerationsLeft(25);
         } else {
           const data = docSnap.data();
           const recentTimestamps = (data.timestamps || []).filter(ts => new Date(ts) >= sevenDaysAgo);
           setGenerationsLeft(25 - recentTimestamps.length);
         }
   
       } catch (err) {
         console.error("Error fetching profile or generation count:", err);
       }
     };
   
     fetchProfileAndGenerations();
   }, [user, db]);

    useEffect(() => {
      const fetchSubjects = async () => {
        try {
          if (!standard) return; // Don't fetch unless we have the user's standard
  
          const q = query(collection(db, 'Standard_Subject_Topic_Master'), where('Standard', '==', parseInt(standard)));
          const snapshot = await getDocs(q);
          const subjectsData = snapshot.docs.map(doc => doc.data().Subject);
          // Deduplicate and sort
          const uniqueSortedSubjects = [...new Set(subjectsData)].sort();
  
          setSubjectList(uniqueSortedSubjects);
          if (!subject && uniqueSortedSubjects.length > 0) {
            setSubject(uniqueSortedSubjects[0]);
          }
        } catch (error) {
          console.error('Error fetching subjects:', error);
        }
      };
  
      fetchSubjects();
    }, [standard, subject]);

  
  const [difficulty, setdifficulty] = useState('Hard');

  useEffect(() => {
    return () => previews.forEach((url) => URL.revokeObjectURL(url));
  }, [previews]);

  const handleFilesChange = (e) => {

    setSelectedStorageImages([]);

    const selectedFiles = Array.from(e.target.files);
    const validFiles = selectedFiles.filter((f) => f.size <= 4 * 1024 * 1024);
    if (validFiles.length < selectedFiles.length)
    {
      setMessage("❌ Some files were over 4MB and cannot not be used.");
      alert('❌ Please upload files below 4MB only');
    }
  // ✅ Append new valid files to the existing list
  setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  setPreviews((prevPreviews) => [
    ...prevPreviews,
    ...validFiles.map((f) => URL.createObjectURL(f)),
  ]);

  if (validFiles.length > 0) {
    uploadManualImagesForReview(validFiles);
  }

  setExtractedText("");
  };

  // Remove one specific image by index
const handleRemoveImage = (index) => {

  if (selectedStorageImages.length > 0) {
    setSelectedStorageImages((prevImages) => {
      const updatedImages = prevImages.filter((_, i) => i !== index);
      setPreviews(updatedImages.map((item) => item.url));
      return updatedImages;
    });
    return;
  }

  setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
};

// Clear all selected images
const handleClearAll = () => {
  setFiles([]);
  setPreviews([]);
  setExtractedText("");
  setSelectedStorageImages([]);
};


    const handleGenerate = async () => {

    setAiResult('');
    setLoading(true);
    setExtractedText("");
    combinedText = "";

      if (!files || !files.length) {
      alert("⚠️ Please provide at least one image.");
      setLoading(false);
    return "";
  }

  try {
    const prompt = "Extract all visible text from these images as plain text only.";

    const callGemini = httpsCallable(functions, 'callGemini');

    for (let file of files) {
      const base64 = await getBase64(file);

      // ✅ Prepare Gemini payload
      const payload = {
        contents: [
          {
            role: "user",
            parts: [
              { text: prompt },
              {
inlineData: {
  mimeType: file.type || "image/jpeg",
  data: base64,
}
              },
            ],
          },
        ],
      };

      // ✅ Call your backend Cloud Function (replace with your deployed URL)
const result = await callGemini(payload);
const data = result.data;

      // ✅ Extract text from Gemini response
    const text =
       data?.candidates?.[0]?.content?.parts?.[0]?.text || "No text found.";

      combinedText += "\n" + text;
    }

  } catch (err) {
    console.error(err);
    alert("⚠️ Failed to extract text. Check console for details.");
    return "";
  }
  
     try {
        const profileRef = doc(db, 'profiles', user?.uid);
        const profileSnap = await getDoc(profileRef);
        if (profileSnap.exists()) {
          const profileData = profileSnap.data();
          setStandard(profileData.standard || 'unspecified');
        }
      } catch (err) {
        console.error('Error fetching user profile:', err);
      }
  
      if (!subject ) {
        alert('Please Provide Subject');
        return;
      }
  
      if (generationsLeft <= 0) {
        alert('Monthly Limit reached. Please try later or pay to unlock unlimited usage.');
        return;
      }

  const topics = selectedTopics && selectedTopics.length > 0 ? selectedTopics : '';
  
  function getQuestionTypes_bytopic(subject, topic) {
      
    const mathsQuestionTypesByTopic = {
      "Addition": ["Fill in the Blanks", "Multiple Choice Questions"],
      "Ascending and Descending Order": ["Arrange in Order", "Fill in the Blanks"],
      "Comparison": ["Greater or Smaller", "Multiple Choice Questions"],
      "Division": ["Fill in the Blanks", "Story Sums"],
      "Four Digit Addition and Subtraction": ["Fill in the Blanks", "Story Sums"],
      "Missing Numbers": ["Fill in the Blanks", "Multiple Choice Questions"],
      "Multiplication": ["Fill in the Blanks", "Story Sums"],
      "Number Names": ["Write the Number", "Write the Name"],
      "Repeated Addition": ["Fill in the Blanks"],
      "Repeated Multiplication": ["Fill in the Blanks"],
      "Repeated Subtraction": ["Fill in the Blanks"],
      "StorySums for Addition and Subtraction": ["Fill in the Blanks"],
      "StorySums for Multiplication and Division": ["Fill in the Blanks"],
      "Subtraction": ["Fill in the Blanks", "Multiple Choice Questions"],
      "Two Digit Multiplication": ["Fill in the Blanks", "Story Sums"]
    };
  
    return mathsQuestionTypesByTopic[topic] || [];
  }

    function getQuestionTypes_onlysubject(subject) {
    const questionTypes = {
      "English Literature": [
        "Question and Answers",
        "Complete the Sentences",
        "Who Said to Whom",
        "Answer in One Word",
        "What is the Meaning of the Following Words",
        "Fill in the Blanks",
        "Make Sentences",
        "Match the Following",
        "True or False"
      ],
      "Hindi Literature": [
        "Question and Answers",
        "Complete the Sentences",
        "Who Said to Whom",
        "Answer in One Word",
        "What is the Meaning of the Following Words",
        "Fill in the Blanks",
        "Make Sentences",
        "Match the Following",
        "True or False"
      ],
      "English Language": [
        "Fill in the Blanks",
        "Paragraph to fill",
        "rewrite the sentence with correct usage",
        "Identify"
      ],
      "Hindi Language": [
        "Fill in the Blanks",
        "Paragraph to fill",
        "rewrite the sentence with correct usage",
        "Identify"
      ],
      "EVS": [
        "Question and Answers",
        "Complete the Sentences",
        "Answer in One Word",
        "Fill in the Blanks",
        "Match the Following",
        "True or False",
        "Multiple Choice Questions",
        "Scrambled One Word"
      ],
      "GK": [
        "Complete the Sentences",
        "Answer in One Word",
        "Fill in the Blanks",
        "Match the Following",
        "True or False",
        "Multiple Choice Questions",
        "Scrambled One Word"
      ],
      "Moral Science": [
        "Question and Answers",
        "Complete the Sentences",
        "Answer in One Word",
        "What is the Meaning of the Following Words",
        "Fill in the Blanks",
        "Make Sentences",
        "Match the Following",
        "True or False",
        "Multiple Choice Questions"
      ],
      "Social Studies": [
        "Complete the Sentences",
        "Answer in One Word",
        "Fill in the Blanks",
        "Match the Following",
        "Jumbled Words",
        "True or False",
        "Multiple Choice Questions",
        "Scrambled One Word"
      ],
      "Science": [
        "Complete the Sentences",
        "Answer in One Word",
        "Fill in the Blanks",
        "Match the Following",
        "Jumbled Words",
        "True or False",
        "Multiple Choice Questions",
        "Scrambled One Word"
      ],
      "Other": [
        "Complete the Sentences",
        "Answer in One Word",
        "Fill in the Blanks",
        "Match the Following",
        "True or False",
        "Multiple Choice Questions"
      ],
      "Computer": [
        "Complete the Sentences",
        "Answer in One Word",
        "Fill in the Blanks",
        "Match the Following",
        "True or False",
        "Multiple Choice Questions",
        "Scrambled One Word No hints or answers"
      ]
    };
     return questionTypes[subject] ;
  }
  
    let prompt = `Create a worksheet for standard ${standard}.\nSubject: ${subject}. \n`;
  
    if (combinedText) {
      prompt += `\nHere is the lesson text to be used strictly:\n"""${combinedText}"""\n 
      Use different parts of the lesson to frame the questions not just one section of it \n`;
    }
  
    prompt += `Do not highlight or identify the answer in the question text in any shape or form,
      For each of the following topics and question types, 
      create 10 sample questions, different from each other across topics and question type:\n`;

       for (let type of getQuestionTypes_onlysubject(subject)) {
              prompt += `- ${type}\n`;
            }

   if(subject != 'Maths')
    {
        if(difficulty === 'Easy')
        {
          prompt +=`Also Please use the following instructions to frame the questions Keep the questions Easy that is small easy to understand sentences for this standard\n`
        }
        if(difficulty === 'Medium')
        {
          prompt +=`Also Please use the following instructions to frame the questions Keep the questions medium difficulty that is medium in length but easy to understand sentences for this standard\n`
        }
        if(difficulty === 'Hard')
        {
          prompt +=`Also Please use the following instructions to frame the questions Keep the questions hard in difficulty that is analytical indepth questions with longer answers\n`
        }
    }
  
    if(subject === 'Maths')
    {
        if(difficulty === 'Easy')
        {
          prompt +=`Also Please use the following instructions to frame the questions Keep the questions Easy for this standard use 2 digit numbers in the questions\n`
        }
        if(difficulty === 'Medium')
        {
          prompt +=`Also Please use the following instructions to frame the questions Keep the questions medium difficulty that is use slightly bigger numbers 2-3 digits in the questions\n`
        }
        if(difficulty === 'Hard')
        {
          prompt +=`Also Please use the following instructions to frame the questions Keep the questions hard in difficulty that is use big numbers 3-4 digits in the questions,complex scenarios\n`
        }
    }
  
    prompt += `\nGroup all the questions first. After all questions, give the answers section.\n
    Please avoid any suggestions or comments in the output.\n`;
  
      setLoading(true);
  
      try {
        const content = await fetchAIResponse(prompt);
  
        if (!content) {
          alert('Failed to generate response from AI.');
          setMessage('AI did not return a response.');
          return;
        }
  
        setAiResult(content);
  
        const docRef = await addDoc(collection(db, 'ai_image_generated_worksheets'), {
          userId: user?.uid || 'anonymous',
          subject,
          extraInfo,
          content,
          timestamp: serverTimestamp(),
          difficulty:difficulty
        });
  
        const storageRef = ref(storage, `ai_worksheets/${user?.uid}/${docRef.id}.txt`);
        await uploadString(storageRef, content);
  
        const uid = user.uid;
        const doc_Generation = doc(db, 'weekly_generations', uid);
        const docSnap = await getDoc(doc_Generation);
        const now = new Date().toISOString();
        const oldTimestamps = (docSnap.data()?.timestamps || []).filter(ts => {
        return new Date(ts) >= get7DayWindow();
        });
  
        const updatedTimestamps = [...oldTimestamps, now];
        await setDoc(doc_Generation, { timestamps: updatedTimestamps });
  
        const todays_date = `${String(new Date().getDate()).padStart(2, '0')}-${["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"][new Date().getMonth()]}-${new Date().getFullYear()}`;
   
        if (UserType === true && new Date(Premiumenddate) >= new Date(todays_date)) {
        setGenerationsLeft(999);
        }
        else{
         setGenerationsLeft(25 - updatedTimestamps.length); 
        }
  
      } catch (err) {
        console.error(err);
        alert('Something went wrong: ' + err.message);
        setMessage('Failed to generate. Please try again.');
      }
      finally {
      setLoading(false); 
      setExtraInfo('');
    }
    };

const extract_text = async() => {
     
      setLoading(true);
      combinedText = "";

      if (!files || !files.length) {
      alert("⚠️ Please provide at least one image.");
      setLoading(false);
    return "";
  }

  try {
    const prompt = "Extract all visible text from these images as plain text only.";

    const callGemini = httpsCallable(functions, 'callGemini');

    for (let file of files) {
      const base64 = await getBase64(file);

      const payload = {
        contents: [
          {
            role: "user",
            parts: [
              { text: prompt },
              {
inlineData: {
  mimeType: file.type || "image/jpeg",
  data: base64,
}
              },
            ],
          },
        ],
      };

const result = await callGemini(payload);
const data = result.data;

    const text =
       data?.candidates?.[0]?.content?.parts?.[0]?.text || "No text found.";

      combinedText += "\n" + text;
    }

    handleNavigation('/AIQuestionTest', { combinedText, subject })

  } catch (err) {
    console.error(err);
    alert("⚠️ Failed to extract text. Check console for details.");
    return "";
  }
}

const handleGenerate_School = async () => {

    setAiResult('');
    setLoading(true);
    setExtractedText("");
    combinedText = "";

      if (!files || !files.length) {
      alert("⚠️ Please provide at least one image.");
      setLoading(false);
    return "";
  }

  try {
    const prompt = "Extract all visible text from these images as plain text only.";

    const callGemini = httpsCallable(functions, 'callGemini');

    for (let file of files) {
      const base64 = await getBase64(file);

      const payload = {
        contents: [
          {
            role: "user",
            parts: [
              { text: prompt },
              {
inlineData: {
  mimeType: file.type || "image/jpeg",
  data: base64,
}
              },
            ],
          },
        ],
      };

const result = await callGemini(payload);
const data = result.data;

    const text =
       data?.candidates?.[0]?.content?.parts?.[0]?.text || "No text found.";


      combinedText += "\n" + text;
    }

  } catch (err) {
    console.error(err);
    alert("⚠️ Failed to extract text. Check console for details.");
    return "";
  }
  
 let textContent = "";

  try {
    const profileRef = doc(db, "profiles", user?.uid);
    const profileSnap = await getDoc(profileRef);
    if (profileSnap.exists()) {
      const profileData = profileSnap.data();
      setStandard(profileData.standard || "unspecified");
    }
  } catch (err) {
    console.error("Error fetching template or profile:", err);
    alert("Error while loading/parsing PDF: " + err.message);
  }


    const templateQuery = query(
      collection(db, "worksheet_school_templates"),
      where("standard", "==", standard),
      where("subject", "==", subject),
      where("school", "==", school)
    );

    const snap = await getDocs(templateQuery);

    if (snap.empty) {
      alert(`No Assessment template found for subject: ${subject} and standard: ${standard} 
Please create in the Eascode Format Worksheet or Provide Manual Instructions at the bottom`);
      return;
    }
    const template_text = snap.docs[0].data().template;

  if (generationsLeft <= 0) {
    alert("Monthly Limit reached. Please try later or pay to unlock unlimited usage.");
    return;
  }

  const topics = selectedTopics && selectedTopics.length > 0 ? selectedTopics : "";

  let prompt = `Create a worksheet for standard ${standard}.\nSubject: ${subject}. \n`;

  if (combinedText) {
    prompt += `\nHere is the lesson text to be used strictly:\n"""${combinedText}"""\n 
    Use different parts of the lesson to frame the questions not just one section of it \n`;
  }

  prompt += `Use the below sample format, type, and number of questions to create the worksheet:\n${template_text}\n`;

  prompt += `Do not highlight or identify the answer in the question text in any shape or form.\n`;

  if(subject != 'Maths')
  {
      if(difficulty === 'Easy')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions Easy that is small easy to understand sentences for this standard\n`
      }
      if(difficulty === 'Medium')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions medium difficulty that is medium in length but easy to understand sentences for this standard\n`
      }
      if(difficulty === 'Hard')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions hard in difficulty that is analytical indepth questions with longer answers\n`
      }
  }

  if(subject === 'Maths')
  {
      if(difficulty === 'Easy')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions Easy for this standard use 2 digit numbers in the questions\n`
      }
      if(difficulty === 'Medium')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions medium difficulty that is use slightly bigger numbers 2-3 digits in the questions\n`
      }
      if(difficulty === 'Hard')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions hard in difficulty that is use big numbers 3-4 digits in the questions,complex scenarios\n`
      }
  }

  prompt += `Group all the questions first. After all questions, give the answers section.\nPlease avoid any suggestions or comments in the output.\n`;

  setMessage("Generating School Format Worksheet from AI...");
  setLoading(true);

  try {
    const content = await fetchAIResponse(prompt);

    if (!content) {
      alert("Failed to generate response from AI.");
      setMessage("AI did not return a response.");
      return;
    }

    setAiResult(content);

    const docRef = await addDoc(collection(db, "ai_image_generated_worksheets"), {
      userId: user?.uid || "anonymous",
      subject,
      extraInfo,
      content,
      timestamp: serverTimestamp(),
      difficulty:difficulty
    });

    const storageRef = ref(storage, `ai_worksheets/${user?.uid}/${docRef.id}.txt`);
    await uploadString(storageRef, content);

    const uid = user.uid;
    const doc_Generation = doc(db, "weekly_generations", uid);
    const docSnap = await getDoc(doc_Generation);
    const now = new Date().toISOString();
    const oldTimestamps = (docSnap.data()?.timestamps || []).filter(
      (ts) => new Date(ts) >= get7DayWindow()
    );

    const updatedTimestamps = [...oldTimestamps, now];
    await setDoc(doc_Generation, { timestamps: updatedTimestamps });

    const todays_date = `${String(new Date().getDate()).padStart(2, "0")}-${[
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ][new Date().getMonth()]}-${new Date().getFullYear()}`;

    if (UserType === true && new Date(Premiumenddate) >= new Date(todays_date)) {
      setGenerationsLeft(999);
    } else {
      setGenerationsLeft(25 - updatedTimestamps.length);
    }

    setMessage("Generation successful!");
  } catch (err) {
    console.error(err);
    alert("Something went wrong: " + err.message);
    setMessage("Failed to generate. Please try again.");
  } finally {
    setLoading(false);
    setExtraInfo("");
  }
};

const Image_to_Worksheet = async () => {

    setAiResult('');
    setLoading(true);
    setExtractedText("");
    combinedText = "";

    const activeFiles = files || [];
    const activeStorageImages = activeFiles.length > 0 ? [] : selectedStorageImages;

      if (!activeFiles.length && !activeStorageImages.length) {
      alert("⚠️ Please provide at least one image.");
      setLoading(false);
    return "";
  }

  try {
    const prompt = "Extract all visible text from these images as plain text only.";

    const callGemini = httpsCallable(functions, 'callGemini');

    for (let file of activeFiles) {
      const base64 = await getBase64(file);

      const payload = {
        contents: [
          {
            role: "user",
            parts: [
              { text: prompt },
              {
inlineData: {
  mimeType: file.type || "image/jpeg",
  data: base64,
}
              },
            ],
          },
        ],
      };

const result = await callGemini(payload);
const data = result.data;

    const text =
       data?.candidates?.[0]?.content?.parts?.[0]?.text || "No text found.";


      combinedText += "\n" + text;
    }

    for (let image of activeStorageImages) {
      const payload = {
        contents: [
          {
            role: "user",
            parts: [
              { text: prompt },
              {
                storageFile: {
                  fullPath: image.fullPath,
                  mimeType: image.mimeType || "image/jpeg",
                },
              },
            ],
          },
        ],
      };

      const result = await callGemini(payload);
      const data = result.data;

      const text =
        data?.candidates?.[0]?.content?.parts?.[0]?.text || "No text found.";

      combinedText += "\n" + text;
    }

  } catch (err) {
    console.error(err);
    alert("⚠️ Failed to extract text. Check console for details.");
    return "";
  }
  
 let textContent = "";

  try {
    const profileRef = doc(db, "profiles", user?.uid);
    const profileSnap = await getDoc(profileRef);
    if (profileSnap.exists()) {
      const profileData = profileSnap.data();
      setStandard(profileData.standard || "unspecified");
    }
  } catch (err) {
    console.error("Error fetching template or profile:", err);
    alert("Error while loading/parsing PDF: " + err.message);
  }


  if (generationsLeft <= 0) {
    alert("Monthly Limit reached. Please try later or pay to unlock unlimited usage.");
    return;
  }

  const topics = selectedTopics && selectedTopics.length > 0 ? selectedTopics : "";

  let prompt = `Understand the question format in this text and convert to a ready to fill worksheet in strictky and exactly the same format ${combinedText} Strictly Group all the questions first and Do not give the answers. \nDo not give  any suggestions or comments in the output.\n`;

//Always add 10 similar questions from your side in the worksheet.
  {/*
  let prompt = `Create a worksheet for standard ${standard}.\nSubject: ${subject}. \n`;

  if (combinedText) {
    prompt += `\nHere is the text from the image  to be used strictly:\n"""${combinedText}"""\n 
    Just use all the text in the Image to make a worksheet in the exact same format \n`;
  }

  prompt += `Do not highlight or identify the answer in the question text in any shape or form.\n`;

  if(subject != 'Maths')
  {
      if(difficulty === 'Easy')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions Easy that is small easy to understand sentences for this standard\n`
      }
      if(difficulty === 'Medium')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions medium difficulty that is medium in length but easy to understand sentences for this standard\n`
      }
      if(difficulty === 'Hard')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions hard in difficulty that is analytical indepth questions with longer answers\n`
      }
  }

  if(subject === 'Maths')
  {
      if(difficulty === 'Easy')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions Easy for this standard use 2 digit numbers in the questions\n`
      }
      if(difficulty === 'Medium')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions medium difficulty that is use slightly bigger numbers 2-3 digits in the questions\n`
      }
      if(difficulty === 'Hard')
      {
        prompt +=`Also Please use the following instructions to frame the questions Keep the questions hard in difficulty that is use big numbers 3-4 digits in the questions,complex scenarios\n`
      }
  }

  prompt += `Group all the questions first. After all questions, give the answers section.\nPlease avoid any suggestions or comments in the output.\n`;
*/}


  setMessage("Converting Image to Worksheet...");
  setLoading(true);

  try {
    const content = await fetchAIResponse(prompt);

    if (!content) {
      alert("Failed to generate response from AI.");
      setMessage("AI did not return a response.");
      return;
    }

    setAiResult(content);

    const docRef = await addDoc(collection(db, "ai_image_generated_worksheets"), {
      userId: user?.uid || "anonymous",
      subject,
      extraInfo,
      content,
      timestamp: serverTimestamp(),
      difficulty:difficulty
    });

    const storageRef = ref(storage, `ai_worksheets/${user?.uid}/${docRef.id}.txt`);
    await uploadString(storageRef, content);

    const uid = user.uid;
    const doc_Generation = doc(db, "weekly_generations", uid);
    const docSnap = await getDoc(doc_Generation);
    const now = new Date().toISOString();
    const oldTimestamps = (docSnap.data()?.timestamps || []).filter(
      (ts) => new Date(ts) >= get7DayWindow()
    );

    const updatedTimestamps = [...oldTimestamps, now];
    await setDoc(doc_Generation, { timestamps: updatedTimestamps });

    const todays_date = `${String(new Date().getDate()).padStart(2, "0")}-${[
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ][new Date().getMonth()]}-${new Date().getFullYear()}`;

    if (UserType === true && new Date(Premiumenddate) >= new Date(todays_date)) {
      setGenerationsLeft(999);
    } else {
      setGenerationsLeft(25 - updatedTimestamps.length);
    }

    setMessage("Generation successful!");
  } catch (err) {
    console.error(err);
    alert("Something went wrong: " + err.message);
    setMessage("Failed to generate. Please try again.");
  } finally {
    setLoading(false);
    setExtraInfo("");
  }
};

    const generatePdfBlob = async () => {
    return new Promise((resolve, reject) => {

      const wrapper = document.createElement('div');
      wrapper.style.position = 'relative';
      wrapper.style.fontFamily = 'Arial, sans-serif';
      wrapper.style.whiteSpace = 'pre-wrap';
      wrapper.style.padding = '40px 40px 40px 40px'; // top, right, bottom, left;
      wrapper.style.width = '90%';

      // Add image
      const placeholderImage = document.createElement('img');
      placeholderImage.src = logo; // <-- replace with actual URL or base64
      placeholderImage.style.display = 'block';
      placeholderImage.style.margin = '0 auto'; // center
      placeholderImage.style.width = '150px';   // adjust size
      placeholderImage.style.height = 'auto';
      wrapper.appendChild(placeholderImage);

      // Add placeholder (first half of first page)
      const placeholder = document.createElement('div');
      placeholder.innerText = 'Eascode';
      placeholder.style.fontSize = '48px';
      placeholder.style.fontWeight = 'bold';
      placeholder.style.textAlign = 'center';
      placeholder.style.marginTop = '10px';
      placeholder.style.marginBottom = '10px';
      wrapper.appendChild(placeholder);

      const placeholder_value = document.createElement('div');
      placeholder_value.innerText = 'For Parents by Parents';
      placeholder_value.style.fontSize = '24px';
      placeholder_value.style.fontWeight = 'bold';
      placeholder_value.style.textAlign = 'center';
      placeholder_value.style.marginTop = '10px';
      placeholder_value.style.marginBottom = '10px';
      wrapper.appendChild(placeholder_value);

    // Add label before URL
    const toolUrlLabel = document.createElement('div');
    toolUrlLabel.innerText = 'For more worksheets based on your school syllabus and pattern visit : :'; 
    toolUrlLabel.style.fontSize = '16px';
    toolUrlLabel.style.fontWeight = 'bold';
    toolUrlLabel.style.textAlign = 'center';
    toolUrlLabel.style.marginBottom = '5px';
    wrapper.appendChild(toolUrlLabel);

    // Add tool URL (clickable)
    const toolUrl = document.createElement('a');
    toolUrl.href = 'https://eascode.web.app/login'; // <-- replace with your tool URL
    toolUrl.innerText = 'https://eascode.web.app/login';
    toolUrl.style.fontSize = '16px';
    toolUrl.style.color = 'blue';
    toolUrl.style.textAlign = 'center';
    toolUrl.style.display = 'block';
    toolUrl.style.marginBottom = '50px';
    toolUrl.style.textDecoration = 'underline';
    wrapper.appendChild(toolUrl);

      // Actual AI result after placeholder
      const content = document.createElement('div');
      content.innerText = aiResult;
      wrapper.appendChild(content);

      //wrapper.innerText = aiResult;
  
      const watermark = document.createElement('div');
      watermark.innerText = 'Eascode';
      watermark.style.position = 'fixed';
      watermark.style.top = '50%';
      watermark.style.left = '50%';
      watermark.style.transform = 'translate(-50%, -50%) rotate(-30deg)';
      watermark.style.fontSize = '120px';
      watermark.style.color = 'rgba(0, 0, 0, 0.05)';
      watermark.style.zIndex = '0';
      watermark.style.pointerEvents = 'none';
      watermark.style.userSelect = 'none';
      watermark.style.width = '100%';
      watermark.style.textAlign = 'center';
      wrapper.appendChild(watermark);

      // Add legal terms (last page footer)
    const legalTerms = document.createElement('div');
    legalTerms.innerText = 
      'Terms & Conditions:\n\n' +
  'This document is provided for personal use only. Unauthorized copying, ' +
  'reproduction, distribution, or modification of any part of this content is strictly prohibited. ' +
  'No portion of this material may be stored in a retrieval system, transmitted, or otherwise ' +
  'used in any form or by any means—electronic, mechanical, photocopying, recording, or otherwise— ' +
  'without the prior written permission of Eascode. All intellectual property rights, including ' +
  'but not limited to copyrights, trademarks, and design rights, are fully reserved.\n\n' +
  '© Eascode Pvt. Ltd.' + new Date().getFullYear()+ 
  '. \n All rights reserved. Unauthorized use of this document or its contents may result in ' +
  'civil and/or criminal liability under applicable laws.\n\n' +
  'By using, viewing, or distributing this document, you expressly agree to comply with these terms.';

    legalTerms.style.fontSize = '12px';
    legalTerms.style.color = '#444';
    legalTerms.style.textAlign = 'justify';
    legalTerms.style.marginTop = '100px';
    legalTerms.style.padding = '20px 40px';
    wrapper.appendChild(legalTerms);
  
      document.body.appendChild(wrapper);
  
      const opt = {
        margin: 0.5,
        filename: 'temp.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      };
  
      html2pdf().set(opt).from(wrapper).outputPdf('blob').then((blob) => {
        document.body.removeChild(wrapper);
        resolve(blob);
      }).catch((err) => {
        document.body.removeChild(wrapper);
        reject(err);
      });
    });
  };

  const handleDownload = async () => {
  const blob = await generatePdfBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Eascode_AI_${subject}_Multiple_Lesson_Multiple_Topics_worksheet.pdf`;
  a.click();
  URL.revokeObjectURL(url);
};

const handleUpload = async () => {

if (!subject) {
      alert('Please fill all required fields.');
      return;
  }

  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) {
    alert('User not logged in');
    return;
  }

  const profilesRef = collection(db, 'profiles');
  const querySnapshot = await getDocs(query(profilesRef, where('uid', '==', user.uid)));

  if (querySnapshot.empty) {
    alert('Profile not found for this user.');
    return;
  }

  const profileData = querySnapshot.docs[0].data();
  const dt = getToday();
  const fileName = `Eascode_AI_Std_${profileData.standard}_${subject}_Multiple_Lesson_Multiple_Topics_worksheet_${dt}`;
  const storageRef = ref(storage, `uploads/${fileName}.pdf`);

  const fileBlob = await generatePdfBlob();  // <--- use PDF Blob here

  setUploading(true);

  const uploadTask = uploadBytesResumable(storageRef, fileBlob);

  uploadTask.on(
    'state_changed',
    (snapshot) => {
      const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      setProgress(prog);
    },
    (error) => {
      console.error(error);
      setUploading(false);
      alert('Error uploading file');
    },
    async () => {
      const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

      await addDoc(collection(db, 'uploads'), {
          fileName,
          fileUrl: downloadURL,
          description : 'AI generated Worksheet',
          subject,
          calculatedFileName: fileName,
          uploadedBy: user.email,
          uid: user.uid,
          uploadTime: serverTimestamp(),
          standard: profileData.standard || '',
          school: profileData.school || '',
          city: profileData.city || '',
          type : 'AI_Worksheet'
      });

      alert('AI-generated file uploaded successfully!');
      setUploading(false);
      setSubject('');
      setProgress(0);
      setAiResult('');
    }
  );
};

async function fetchAIResponse(prompt) {

  const callGemini = httpsCallable(functions, 'callGemini');

  // 2. Try Gemini as fallback
  try {
    const result = await callGemini({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      generationConfig: {
        maxOutputTokens: 8192,
        temperature: 0.7
      }
    });

    // 🛡️ Secure Note: The App Check token was sent automatically!
    // result.data contains the body of the response from your backend
    return result.data.candidates?.[0]?.content?.parts?.[0]?.text;

  } catch (err) {
    console.error('Gemini error:', err.message);
    
    // Check for specific security failures
    if (err.code === 'failed-precondition') {
      alert("Security Check Failed: Please refresh the page.");
    }
  }

  alert("All AI engines failed. Try again later.");
  return null;
}

  return (
    <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white py-2 sm:py-6 px-2 sm:px-6 lg:px-8 font-sans">
      <div className="w-full mx-auto bg-white/80 backdrop-blur-xl rounded-[1rem] sm:rounded-[2rem] shadow-2xl shadow-indigo-500/10 border border-white p-3 sm:p-8 relative overflow-hidden">
        
        {/* Top Nav & Header */}
        <div className="flex items-center justify-between mb-2 sm:mb-4 w-full gap-2">
          <div className="flex-1 flex justify-start min-w-0">
            <BackHomeButton backState={{}} disabled={loading} />
          </div>
          <div className="flex-auto text-center px-1 sm:px-4 shrink-0">
            <h2 className="text-sm sm:text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight leading-tight whitespace-nowrap">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600">Vision Worksheet Generator</span>
            </h2>
          </div>
          <div className="flex-1 flex justify-end min-w-0">
          </div>
        </div>

        {/* Toggle JSX */}
        <div style={toggleContainerStyle}>
          <div style={toggleStyle} onClick={() => handleToggleChange(activeMode === 'image' ? 'lesson' : 'image')}>
            <div style={getSliderStyle(activeMode)}></div>
            <div style={getLabelStyle('lesson', activeMode)}>📚 From Lesson</div>
            <div style={getLabelStyle('image', activeMode)}>📸 From Image</div>
          </div>
        </div>

        <div className="text-center mb-4 sm:mb-8">
          <p className="text-[10px] sm:text-sm text-slate-500 font-medium w-full mx-auto px-2">
            Use this tool to Upload Multiple Images to create worksheets and quizzes from any subject, any standard, any school.
          </p>
        </div>

        {/* Quota Banner */}
        <div className="mb-4 sm:mb-6 bg-slate-400 text-white rounded-lg sm:rounded-2xl p-3 sm:p-4 shadow-lg relative overflow-hidden">
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3 relative z-10">
            <div className="flex items-center gap-2 shrink-0">
              <span className="text-lg sm:text-2xl">📸</span>
              <div>
                <h4 className="text-[11px] sm:text-base font-bold leading-none">Vision AI Engine</h4>
                <p className="text-[9px] sm:text-xs text-indigo-200 mt-0.5">Extracts text and generates worksheets.</p>
              </div>
            </div>
            
            <div className="flex flex-wrap items-center gap-2 sm:gap-3">
              <div className="bg-slate-800/80 border border-slate-700 px-2 py-1 sm:px-3 sm:py-1.5 rounded-md sm:rounded-lg flex flex-col justify-center min-w-[60px]">
                <span className="text-[7px] sm:text-[9px] font-bold text-slate-400 uppercase leading-none mb-0.5">Quota</span>
                <span className="text-[10px] sm:text-xs font-black text-emerald-400 leading-none">{generationsLeft} Left</span>
              </div>
              <div className="bg-slate-800/80 border border-slate-700 px-2 py-1 sm:px-3 sm:py-1.5 rounded-md sm:rounded-lg flex flex-col justify-center min-w-[80px]">
                <span className="text-[7px] sm:text-[9px] font-bold text-slate-400 uppercase leading-none mb-0.5">Premium</span>
                <span className="text-[10px] sm:text-xs font-black text-white leading-none truncate">{Premiumenddate.toLocaleString().split(',')[0] || 'Not Set'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Storage Image Form View */}
<div className="mb-4 sm:mb-6 bg-slate-50 border border-slate-200 p-3 sm:p-5 rounded-lg sm:rounded-2xl shadow-sm">
  <div className="grid grid-cols-1 gap-3 mb-4">
    <div>
      <label className="block text-[11px] sm:text-sm font-bold text-slate-700 mb-1">
        Subject
      </label>
      <select
        value={subject}
        onChange={(e) => {
          setSubject(e.target.value);
          if (selectedStorageImages.length > 0) {
            setPreviews([]);
          }
          setSelectedStorageImages([]);
        }}
        className="w-full bg-white border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 text-[11px] sm:text-base font-semibold text-slate-700"
      >
        {[...new Set([...subjectList, "English Language", "Hindi Language", "Maths", "Other"])]
          .sort()
          .map((subj) => (
            <option key={subj} value={subj}>
              {subj}
            </option>
          ))}
      </select>
    </div>
  </div>

  {loadingStorageImages ? (
    <div className="h-40 flex items-center justify-center text-xs font-bold text-slate-500">
      Loading images...
    </div>
  ) : storageImageError ? (
    <div className="text-xs font-bold text-rose-600 bg-rose-50 border border-rose-200 rounded-xl p-3">
      {storageImageError}
    </div>
  ) : !subject ? (
    <div className="text-xs font-bold text-slate-500 bg-white border border-slate-200 rounded-xl p-3">
      Select a subject to see available worksheet images.
    </div>
  ) : storageImages.length === 0 ? (
    <div className="text-xs font-bold text-slate-500 bg-white border border-slate-200 rounded-xl p-3">
      No images found.
    </div>
  ) : (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {storageImages.map((image) => {
          const isSelected = selectedStorageImages.some((item) => item.fullPath === image.fullPath);

          return (
            <div
              key={image.fullPath}
              className={`bg-white rounded-2xl shadow-md border overflow-hidden ${
                isSelected ? "border-indigo-500 ring-2 ring-indigo-200" : "border-slate-200"
              }`}
            >
              <div className="h-[320px] bg-slate-100 flex items-center justify-center overflow-hidden">
                <img
                  src={image.url}
                  alt={image.name}
                  className="w-full h-full object-contain"
                />
              </div>

              <div className="p-3">
                <p className="text-xs font-bold text-slate-800 line-clamp-2 break-all">
                  {image.name}
                </p>

                <button
                  type="button"
                  onClick={() => handleSelectStorageImage(image)}
                  disabled={loading}
                  className={`mt-3 w-full py-2 px-3 rounded-full text-xs font-bold transition ${
                    isSelected
                      ? "bg-indigo-600 text-white"
                      : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                  }`}
                >
                  {isSelected ? "Selected" : "Select Image"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </>
  )}
</div>

        {/* Image Upload Area */}
        <div className="mb-4 sm:mb-6 bg-slate-50 border border-slate-200 p-3 sm:p-5 rounded-lg sm:rounded-2xl shadow-sm">
          <label className="block text-[11px] sm:text-sm font-bold text-indigo-900 mb-2 uppercase tracking-wider">
            Click or Upload Images
          </label>
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleFilesChange}
            className="w-full bg-white border-2 border-dashed border-slate-300 rounded-md sm:rounded-xl px-2 py-2 sm:px-3 sm:py-4 focus:border-indigo-500 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer file:mr-4 file:py-1.5 file:px-4 file:rounded-full file:border-0 file:text-[10px] sm:file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
          />

          {previews.length > 0 && (
            <div className="mt-4">
              <div className="flex flex-wrap gap-3">
                {previews.map((src, index) => (
                  <div key={index} className="relative group">
                    <img
                      src={src}
                      alt={`Preview ${index}`}
                      className="w-20 h-20 sm:w-28 sm:h-28 object-cover rounded-lg sm:rounded-xl shadow-sm border border-slate-200"
                    />
                    <button
                      onClick={() => handleRemoveImage(index)}
                      className="absolute -top-2 -right-2 bg-rose-500 text-white w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shadow-md hover:bg-rose-600 hover:scale-110 transition-all"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
              <button
                onClick={handleClearAll}
                className="mt-3 bg-slate-600 text-white px-4 py-1.5 rounded-md sm:rounded-lg text-[10px] sm:text-xs font-bold hover:bg-slate-700 transition-colors shadow-sm"
              >
                Clear All
              </button>
            </div>
          )}
        </div>

                {/* Action Buttons */}
        <div className="space-y-2 sm:space-y-4 mb-4 sm:mb-6">
          <div className="grid grid-cols-1 sm:grid-cols-1 gap-2 sm:gap-4 w-full">
            {generationsLeft > 0 ? (
              <>

                <button
                  onClick={Image_to_Worksheet}
                  disabled={loading}
                  //className="w-full bg-white border-2 border-slate-200 text-slate-700 p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base hover:border-emerald-500 hover:text-emerald-600 transition-all duration-300 disabled:opacity-50"
                  className="w-full bg-slate-700 text-white p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base hover:bg-indigo-600 transition-all duration-300 disabled:opacity-50"
                >
                  {loading ? 'Converting...' : '🖼️ ⇒ 📄 Convert Images to Worksheet'}
                </button>
{/*
                  <button
                    onClick={() => {
                      handleGenerate();
                      setsimilar(true);
                    }}
                    disabled={loading}
                    className="w-full bg-slate-700 text-white p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base hover:bg-indigo-600 transition-all duration-300 disabled:opacity-50"
                  >
                  <span className="flex items-center justify-center gap-1.5 sm:gap-2">
                    {loading ? <div className="w-3 h-3 sm:w-5 sm:h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> : null}
                    {loading ? 'Working...' : '🖼️ ⇒ 📄 Generate Similar Worksheet '}
                  </span>
                </button>



                <button
                  onClick={extract_text}
                  disabled={loading}
                  className="col-span-1 sm:col-span-2 w-full bg-emerald-50 border-2 border-emerald-200 text-emerald-700 p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base hover:bg-emerald-100 transition-all duration-300 disabled:opacity-50"
                >
                  {loading ? '⏳ Generating Quiz...' : '📝 Convert Image to Quiz'}
                </button>
*/}
              </>
            ) : (
              <div className="col-span-1 sm:col-span-2 w-full flex justify-center p-2 sm:p-4 bg-rose-50 border border-rose-200 rounded-lg sm:rounded-2xl">
                <RazorpayButton />
              </div>
            )}
          </div>
        </div>

        {similar === 'true' && (
<>
        {/* Form Grid: Subject & Difficulty */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6 mb-4 sm:mb-6">
          <div className="space-y-1">
            <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose Subject</label>
            <select
              value={subject}
              disabled={loading}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
            >
              <option value="">Select Subject</option>
              <option value="Other">Other</option>
              {[...new Set([...subjectList, "English Language", "Hindi Language", "Maths"])].sort().map((subj, idx) => (
                <option key={idx} value={subj}>{subj}</option>
              ))}
            </select>
          </div>

          <div className="space-y-1">
            <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose Lesson</label>
            <select
              value={subject}
              disabled={loading}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
            >
              <option value="">Select Subject</option>
              <option value="Other">Other</option>
              {[...new Set([...subjectList, "English Language", "Hindi Language", "Maths"])].sort().map((subj, idx) => (
                <option key={idx} value={subj}>{subj}</option>
              ))}
            </select>
          </div>

          <div className="space-y-1 animate-in fade-in zoom-in-95 duration-200">
            <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1 flex flex-wrap items-baseline gap-1">
              Difficulty Level
              <span className="text-[9px] sm:text-[10px] text-rose-500 font-medium">(varies question types*)</span>
            </label>
            <select
              value={difficulty}
              onChange={(e) => setdifficulty(e.target.value)}
              required
              className={`w-full border-2 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 text-[11px] sm:text-base font-bold transition-all outline-none cursor-pointer appearance-none
                ${difficulty === 'Easy' ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : 
                  difficulty === 'Medium' ? 'bg-amber-50 border-amber-200 text-amber-800' : 
                  'bg-rose-50 border-rose-200 text-rose-800'}`}
            >
              <option value="Easy">🟢 Easy</option>
              <option value="Medium">🟡 Medium</option>
              <option value="Hard">🔴 Hard</option>
            </select>
          </div>
        </div>
</>
         )}

        {/* Live Preview Area */}
        <div className="mt-4 sm:mt-10 pt-4 sm:pt-8 border-t border-slate-200 space-y-3 sm:space-5">
          <div className="flex flex-row items-center justify-between">
            <label className="text-[13px] sm:text-lg font-bold text-slate-800">Live Preview</label>
            {uploading && (
              <span className="px-2 py-0.5 sm:px-3 sm:py-1 bg-emerald-100 text-emerald-700 text-[8px] sm:text-[10px] font-bold rounded-full animate-pulse">
                UPLOADING {progress}%
              </span>
            )}
          </div>
          
          <textarea 
            className="w-full bg-white text-slate-900 font-mono text-[10px] sm:text-sm leading-tight sm:leading-relaxed p-3 sm:p-5 rounded-lg sm:rounded-2xl border-2 border-slate-200 outline-none h-40 sm:h-80 resize-y focus:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 transition-all custom-scrollbar" 
            value={aiResult} 
            onChange={(e) => setAiResult(e.target.value)}
          />

          <div className="grid grid-cols-2 gap-2 sm:gap-4 w-full">
            {/* DOWNLOAD BUTTON */}
            <button 
              onClick={handleDownload} 
              disabled={!aiResult.trim()} 
              className="w-full bg-white border-2 border-slate-200 text-slate-700 p-2 sm:p-4 rounded-lg sm:rounded-xl font-bold text-[10px] sm:text-base hover:bg-slate-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              📥 Download PDF
            </button>

            {/* UPLOAD BUTTON */}
            <button
              onClick={handleUpload}
              disabled={uploading || !aiResult.trim()}
              className="w-full bg-emerald-500 text-white p-2 sm:p-4 rounded-lg sm:rounded-xl font-bold text-[10px] sm:text-base hover:bg-emerald-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed relative overflow-hidden"
            >
              {uploading ? (
                <div className="absolute inset-0 bg-emerald-600 flex items-center justify-center" style={{ width: `${progress}%` }}>
                  <span className="absolute w-full text-center z-10 text-white text-[9px] sm:text-sm">Uploading {progress}%</span>
                </div>
              ) : '📤 Upload To Eascode'}
            </button>

            
          </div>
        </div>

        {/* Out of Credits Alert */}
        {generationsLeft <= 0 && (
          <div className="mt-4 sm:mt-8 p-2 sm:p-4 bg-rose-50 border border-rose-200 rounded-md sm:rounded-xl text-center">
            <p className="text-rose-600 font-bold text-[10px] sm:text-sm">You have reached the Monthly limit. Please Subscribe to Eascode Premium to unlock unlimited usage.</p>
          </div>
        )}

        <footer className="mt-6 sm:mt-14 text-center text-slate-400 text-[9px] sm:text-xs font-medium">
          © {new Date().getFullYear()} Eascode All Rights Reserved.
        </footer>

      </div>
    </div>
  );
}

// --- TOGGLE STYLES (Kept exactly identical to Eascode_Agent_Lesson) ---
const toggleContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '20px',
  marginTop: '10px',
  width: '100%'
};

const toggleStyle = {
  display: 'flex',
  background: '#e2e8f0',
  borderRadius: '30px',
  padding: '6px',
  width: '320px',
  position: 'relative',
  cursor: 'pointer',
  boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.06)'
};

const getSliderStyle = (activeMode) => ({
  position: 'absolute',
  top: '6px',
  left: activeMode === 'lesson' ? '6px' : '160px',
  width: '154px',
  height: '36px',
  background: 'linear-gradient(to right, #6a11cb, #2575fc)',
  borderRadius: '25px',
  transition: 'left 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
  zIndex: 1,
  boxShadow: '0 2px 8px rgba(37, 117, 252, 0.3)'
});

const getLabelStyle = (mode, activeMode) => ({
  flex: 1,
  textAlign: 'center',
  padding: '8px 0',
  zIndex: 2,
  fontWeight: '800',
  fontSize: '14px',
  color: activeMode === mode ? 'white' : '#64748b',
  transition: 'color 0.3s ease',
  userSelect: 'none'
});
// -------------------------------

export default Eascode_Vision;
